// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface LoaderProps extends ExpandStyles<LoaderStyles> {
    height?: number | null;
    size?: number;
    testSelector?: string;
}

export interface LoaderStyles {
    wrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const loaderStyles: LoaderStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
};

const Loader: FC<LoaderProps> = ({ height = 150, extendedStyles, overridedStyles, testSelector }) => {
    const styles = useExpandProps(loaderStyles, extendedStyles, overridedStyles);

    const wrapperCss = css`
        ${cssProp("min-height", height, pxToRem)}
        ${styles.wrapper?.css}
    `;

    return (
        <StyledWrapper {...styles.wrapper} css={wrapperCss}>
            <LoadingSpinner {...styles.spinner} data-test-selector={testSelector} />
        </StyledWrapper>
    );
};

export default Loader;
